import { useState, useEffect } from "react";

import { SCREEN_WIDTHS } from "../constants/enums";

const getWindowDimensions = () => {
  const isBrowser = typeof window !== "undefined";

  if (isBrowser) {
    const { innerWidth: width } = window;

    return {
      width,
    };
  } else {
    return {
      width: 1200,
    };
  }
};

const useWindowDimensions = () => {
  const isBrowser = typeof window !== "undefined";

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    if (isBrowser) {
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [isBrowser]);

  const isSmallerThanXXlScreen =
    windowDimensions.width < SCREEN_WIDTHS.EXTRA_EXTRA_LARGE;
  const isSmallerThanXlScreen =
    windowDimensions.width < SCREEN_WIDTHS.EXTRA_LARGE;
  const isSmallScreen = windowDimensions.width < SCREEN_WIDTHS.LARGE;
  const isTablet = windowDimensions.width < SCREEN_WIDTHS.MEDIUM;
  const isSmallerTablet = windowDimensions.width < SCREEN_WIDTHS.SMALLER_MEDIUM;
  const isMobile = windowDimensions.width < SCREEN_WIDTHS.SMALL;

  return {
    ...windowDimensions,
    isSmallerThanXXlScreen,
    isSmallerThanXlScreen,
    isSmallScreen,
    isTablet,
    isSmallerTablet,
    isMobile,
  };
};

export default useWindowDimensions;
